<template>
  <div class="container my-5" v-if="!!data">
    <div class="mb-3 text-center">
      <h3 class="d-inline me-5">Basic Info</h3>
    </div>
    <div class="row">
      <!-- Company Name -->
      <div class="inner-container col-md-6 p-3">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title">Company Name</h5>
            <hr />
            <div class="mb-3">
              <label class="form-label" for="inputName"
                >Company Name in English</label
              >
              <input
                type="text"
                class="form-control"
                id="inputName"
                v-model="companyNameEn"
                @change="update('companyNameEn', companyNameEn)"
                :placeholder="data.companyNameEn"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="inputName"
                >Company Name in Chinese</label
              >
              <input
                type="text"
                class="form-control"
                id="inputName"
                v-model="companyNameCh"
                @change="update('companyNameCh', companyNameCh)"
                :placeholder="data.companyNameCh"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Contact -->
      <div class="inner-container col-md-6 p-3">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Contact Information</h5>
            <hr />
            <div class="row">
              <div class="mb-3 col-12">
                <label class="form-label" for="inputEmail">Email</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputEmail"
                  v-model="email"
                  @change="update('emailAddress', email)"
                  :placeholder="data.emailAddress"
                />
              </div>
              <div class="mb-3 col-lg-6">
                <label class="form-label" for="inputPhone">Phone Number</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputPhone"
                  v-model="phoneNumber"
                  @change="update('phoneNumber', phoneNumber)"
                  :placeholder="data.phoneNumber"
                />
              </div>
              <div class="mb-3 col-lg-6">
                <label class="form-label" for="inputPhone">Fax Number</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputTax"
                  v-model="faxNumber"
                  @change="update('faxNumber', faxNumber)"
                  :placeholder="data.faxNumber"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Company Address -->
      <div class="inner-container col-md-6 p-3">
        <div class="card ">
          <div class="card-body">
            <h5 class="card-title">Company Address</h5>
            <hr />
            <div class="mb-3">
              <label class="form-label" for="inputAddress">Street</label>
              <input
                type="text"
                class="form-control"
                id="inputAddress"
                v-model="street"
                @change="update('street', street)"
                :placeholder="data.street"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="inputCity">City</label>
              <input
                type="text"
                class="form-control"
                id="inputCity"
                v-model="city"
                @change="update('city', city)"
                :placeholder="data.city"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="inputState">Province</label>
              <input
                type="text"
                class="form-control"
                id="inputState"
                v-model="province"
                @change="update('province', province)"
                :placeholder="data.province"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="inputZip">Post Code</label>
              <input
                type="text"
                class="form-control"
                id="inputZip"
                v-model="postcode"
                @change="update('postcode', postcode)"
                :placeholder="data.postcode"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="inputLat">Latitude</label>
              <input
                type="text"
                class="form-control"
                id="inputLat"
                v-model="latitude"
                @change="update('latitude', latitude)"
                :placeholder="data.latitude"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="inputLon">Longitude</label>
              <input
                type="text"
                class="form-control"
                id="inputLon"
                v-model="longitude"
                @change="update('longitude', longitude)"
                :placeholder="data.longitude"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Introduction -->
      <div class="inner-container col-md-6 p-3">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title">Introduction</h5>
            <hr />
            <div class="row h-100">
              <div class="mb-3 col-12">
                <label class="form-label" for="Textarea"
                  >Introduction in English</label
                >
                <textarea
                  style="height: 180px"
                  class="form-control"
                  :placeholder="data.companyDescriptionEn"
                  id="Textarea"
                  v-model="descriptionEn"
                  @change="update('companyDescriptionEn', descriptionEn)"
                ></textarea>
              </div>
              <div class="mb-3 col-12">
                <label class="form-label" for="Textarea"
                  >Introduction in Chinese</label
                >
                <textarea
                  style="height: 180px"
                  class="form-control"
                  :placeholder="data.companyDescriptionCh"
                  id="Textarea"
                  v-model="descriptionCh"
                  @change="update('companyDescriptionCh', descriptionCh)"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inner-container">
      <!-- Logo Image -->
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Logo Image</h5>
          <hr />
          <div class="row mb-3">
            <div class="col-md-6 d-flex flex-column">
              <label class="form-label col" for="inputZip">Preview</label>
              <img
                class="preview-logo"
                :src="
                  $webDomain + '/' + data.iconImageType + '/' + data.iconImage
                "
                alt="not found"
              />
            </div>
            <div class="col-md-6 pt-5">
              <button
                type="button"
                class="btn btn-secondary m-3"
                @click="showModal"
              >
                Change Logo
              </button>
              <button
                class="btn btn-primary m-3"
                type="submit"
                @click="submitChanges"
              >
                Save All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-if="displayModal" @close-modal-event="hideModal" />
  </div>
</template>
<script>
import Modal from "./Modal.vue";
import axios from "axios";
import authHeader from "../../services/authHeader";
export default {
  name: "AdminBasic",
  components: {
    Modal,
  },
  data() {
    return {
      displayModal: false,
      data: null,
      companyNameEn: "",
      companyNameCh: "",
      email: "",
      street: "",
      city: "",
      province: "",
      postcode: "",
      phoneNumber: "",
      faxNumber: "",
      latitude: "",
      longitude: "",
      descriptionEn: "",
      descriptionCh: "",
      obj: {},
    };
  },
  created() {
    axios
      .get(this.$webDomain + "/gardenInit/GardenBasic")
      .then((response) => (this.data = response.data.data[0]));
  },
  methods: {
    showModal() {
      this.displayModal = true;
    },
    hideModal() {
      this.displayModal = false;
    },
    update(key, value) {
      if (key === "longitude" || key === "latitude") {
        this.obj[key] = parseFloat(value);
      } else {
        this.obj[key] = value;
      }
    },
    closeModal() {
      this.$emit("close-modal-event");
    },
    submitChanges() {
      this.obj["itemId"] = "62146c54a48bdd798f4ea0cb";
      axios
        .put(this.$webDomain + "/garden/GardenBasic", this.obj, {
          headers: authHeader(),
        })
        .then(function(response) {
          console.log(response);
          window.location.reload();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.card-body {
  padding: 1.5rem 1.5rem !important;
}

.logo {
  height: 100px;
}

.preview-logo {
  max-width: 280px;
  /* width: 280px; */
  height: auto;
}
</style>
